<template>
  <v-container>
    <v-row class="">
      <v-col cols="12" md="6">
        <v-card
          class="d-flex mx-auto rounded flex-column justify-center align-center blue-shadow"
          tile
          hover
          width="250px"
          height="250px"
          elevation="5"
        >
          <v-icon color="blue darken-3" x-large>mdi-cellphone</v-icon>
          <v-card-title class="text-center font-weight-bold">{{
            enToFa("09387962629")
          }}</v-card-title>
          <v-card-title class="font-weight-bold py-0">شماره تماس</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card
          class="d-flex mx-auto rounded flex-column justify-center align-center green-shadow"
          tile
          hover
          width="250px"
          height="250px"
          elevation="5"
        >
          <v-icon color="green darken-3" x-large>mdi-whatsapp</v-icon>
          <v-card-title class="text-center font-weight-bold">۰۹۹۱۶۳۱۴۶۹۸</v-card-title>
          <v-card-title class="font-weight-bold py-0"
            >شماره واتس آپ</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card
          href="https://www.instagram.com/mdalborz"
          target="_blank"
          class="d-flex mx-auto rounded flex-column justify-center align-center purple-shadow"
          tile
          hover
          width="250px"
          height="250px"
          elevation="5"
        >
          <v-icon color="purple" x-large>mdi-instagram</v-icon>
          <v-card-title class="text-center font-weight-bold"
            >mdalborz</v-card-title
          >
          <v-card-title class="font-weight-bold py-0"
            >آی دی اینستاگرام</v-card-title
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { enToFa } from "@/tools/Utils";

export default {
  name: "contactUs",
  methods: {
    enToFa: enToFa,
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 1rem;
}
p {
  font-weight: bold;
}
.purple-shadow{
  box-shadow: purple 0 0 21px -7px !important;
}
.blue-shadow{
  box-shadow: darkblue 0 0 21px -7px !important;
}
.green-shadow{
  box-shadow: green 0 0 21px -7px !important;
}
</style>
